import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { ToggleBatchPublicVisibilityBody } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const toggleBatchPublicVisibility = createAsyncThunk<void, ToggleBatchPublicVisibilityBody, { extra: Partial<Dependencies> }>(
  "batches/toggleBatchPublicVisibility",
  async (body: ToggleBatchPublicVisibilityBody, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.toggleBatchPublicVisibility(body);
  },
);

export const resetToggleBatchPublicVisibility = createAction("batches/resetToggleBatchPublicVisibility");
